import { createContext } from 'react';

// ── FileDragContext ───────────────────────────────────────────────────

/**
 * Value provided by {@link FileDragContext}.
 */
export type FileDragContextValue = {
	/**
	 * `true` while a file drag is active anywhere over the chat frame.
	 *
	 * Populated by the frame-level {@link useFileDrag} detection in
	 * `ChatMessages`.  Consumed by `FormWithDrop` to show the drop-zone
	 * overlay on the footer without requiring the pointer to be directly
	 * over the form element.
	 */
	isDraggingFileOver: boolean;
};

/**
 * Shares the frame-level file-drag detection state with descendants.
 *
 * Provide this context at the `ChatMessages` level so that `FormWithDrop`
 * (deep inside the footer) can react to drags that enter any part of the
 * chat frame, not only the form area.
 */
export const FileDragContext = createContext<FileDragContextValue>({
	isDraggingFileOver: false,
});
